module.exports = __webpack_public_path__ + "94d868397e84652ed8f18f82b17be798.MP3";